<template>
  <pdp-layout>
    <template v-for="slot in Object.keys(slots)" #[slot]="slotProps">
      <template v-if="slot === 'size-and-fit'">
        <template v-if="!$feature.tempShowATCAboveFold || !$viewport.lg">
          <slot name="size-and-fit" />
        </template>
      </template>
      <slot v-else :name="slot" v-bind="slotProps" />
    </template>
  </pdp-layout>
</template>

<script lang="ts" setup>
import PdpLayout from '#commerce/components/pdp/Layout.vue'

const slots = useSlots()
</script>
